import Button from "@material-ui/core/Button";
import Card from "react-bootstrap/Card";
import ielts from "./images/ielts.png";
import solo from "./images/solo.png";
import ROBOTICS from "./images/ROBOTICS.jpg";
import LIDAR from "./images/LIDAR.jpg";
import roboracerCert from "../assets/img/roboracer_certificate.png";

const Achievements = () => {
    const items = [
        {
            img: roboracerCert,
            cardTitle: "Roboracer 2nd Place",
            cardText:
                "25th Roboracer International Autonomous Racing Competition at the 2025 IEEE Intelligent Vehicles Symposium (IV 2025), Cluj-Napoca, Romania.<br/>Awarded to SZEnergy.",
            btnText: "View Certificate",
            btnUrl: "/src/assets/img/roboracer_certificate.png", // Link to image for larger view
        },
        {   
            img:LIDAR,
            cardTitle: "Advanced LiDAR Data Processing and Object Detection in Robotics",
            cardText: "Conducted training session <br/> 10-14 February, 2025",
            btnText: "Training Certificate",
            btnUrl: "/src/assets/img/LIDAR_certificate.png", // Link to image for larger view
        },
        {   
            img:ROBOTICS,
            cardTitle: "Fundamentals of Robotics & Industrial Automation",
            cardText: "Issued on: <br/>  28 June, 2024",
            btnText: "See Credential",
            btnUrl: "https://www.coursera.org/account/accomplishments/verify/R33RP4QFPYGA",
        },
        {
            img: ielts,
            cardTitle: "IELTS Academic",
            cardText: "Issued on: <br/>  18 December 2021",
            btnText: "See Credential",
            btnUrl: "https://ieltsregistration.britishcouncil.org/test-details/6903870/results",
        },
        {
            img: solo,
            cardTitle: "Python Core Certificate",
            cardText: "Issued on: <br/>  24 February, 2022",
            btnText: "See Credential",
            btnUrl: "https://www.sololearn.com/Certificate/1073-25073071/pdf/",
        },
        {
            img: solo,
            cardTitle: "Python for Data Science Certificate",
            cardText: "Issued on: <br/>  24 February, 2022",
            btnText: "See Credential",
            btnUrl: "https://www.sololearn.com/Certificate/1073-25073071/pdf/",
        }
    ];
    return (
        <section id="achievements" className="about background-alt">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <span className="section-index">07 — Recognition</span>
                    <h2>Awards, credentials, and engineering milestones</h2>
                </div>
                <div className="row d-flex justify-content-center">
                    {items.map((data, i) => (
                        <div
                            className="col-sm-3 d-flex justify-content-center"
                            key={i}
                        >
                       
                            <Card
                                style={{
                                    width: "16rem",
                                    padding: "20px",
                                    background: "var(--card-bg)",
                                    border: "1px solid var(--border-color)",
                                    boxShadow: "0 20px 40px var(--shadow-color)",
                                    borderRadius: "18px",
                                }}
                                className="text-center achievement-card"
                            >
                                <Card.Img variant="top" src={data.img} />
                                <Card.Body>
                                    <Card.Title
                                        className="achievement-card-title"
                                    >
                                        {data.cardTitle}
                                    </Card.Title>
                                    <br></br>
                                    <div className="achievement-card-text">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: data.cardText,
                                            }}
                                        ></div>
                                    </div>
                                    {data.btnText && (
                                        <Button
                                            variant="contained"
                                            className="themed-button"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={data.btnUrl}
                                            disableElevation
                                        >
                                            {data.btnText}
                                        </Button>
                                    )}
                                </Card.Body>
                            </Card>
                            <br></br>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Achievements;
